<template>
  <d-modal
    class="patients-form-decisions"
    style="background-color: rgba(0,0,0,0.6)!important;">
    <button
      @click.prevent="onClosePopup"
      :class="['mr-1', 'decisions-close-button', show ? 'decisions-close-button-load' : 'decisions-close-button-hidden']">
      <i class="material-icons">close</i>
    </button>
    <d-modal-header>
      <d-modal-title>
        <h3 class="page-title">
          <template v-if="isEdit">Edycja orzeczenia</template>
          <template v-else>Dodawanie orzeczenia</template>
        </h3>
      </d-modal-title>
    </d-modal-header>
    <d-modal-body>
      <div
        v-if="!isViewLoaded"
        class="pb-3 pt-3 text-center overlay-loading" style="z-index: 100;">
        <div class="spinner-load m-0 mb-4"  style="position: sticky; top: calc(50% - 40px); left: calc(50%);">
          <div class="spinner-border spinner-border-sm decision-spinner" role="status"></div>
        </div>
      </div>

      <validation-observer
        ref="patients-form-decision"
        tag="form" >
        <div class="form-group">
          <label for="institution">
            Przypisana placówka:
          </label>
          <validation-provider
            :rules="'required'"
            name="institution"
            v-slot="{ errors }">
            <div
              :class="{
                'form-control is-select': true,
                'is-invalid': errors.length
              }">
              <v-select
                :options="allInstitutions"
                v-model="data.institution_id"
                :reduce="institution => institution.id"
                placeholder="Wybierz placówkę..."
                label="name"
                name="institution">
                <template slot="option" slot-scope="option">
                  <div class="d-center">
                    {{ option.name }}
                  </div>
                </template>
                <template slot="selected-option" slot-scope="option">
                  <div class="selected d-center">
                    {{ option.name }}
                  </div>
                </template>
                <template slot="no-options">
                  Brak pasujących rezultatów
                </template>
              </v-select>
            </div>
            <div class="invalid-feedback">
              {{ errors[0] }}
            </div>
          </validation-provider>
        </div>
        <div
          v-if="data.institution_id"
          class="form-group">
          <label for="decision">
            Typ orzeczenia:
          </label>
          <validation-provider
            :rules="'required'"
            name="decision"
            v-slot="{ errors }">
            <div
              :class="{
                'form-control is-select': true,
                'is-invalid': errors.length
              }">
              <v-select
                :options="templatesList"
                v-model="data.id"
                :reduce="boss => boss.id"
                placeholder="Wybierz typ orzeczenia..."
                label="name"
                name="decision">
                <template slot="option" slot-scope="option">
                  <div class="d-center">
                    {{ option.name }}
                  </div>
                </template>
                <template slot="selected-option" slot-scope="option">
                  <div class="selected d-center">
                    {{ option.name }}
                  </div>
                </template>
                <template slot="no-options">
                  Brak pasujących rezultatów
                </template>
              </v-select>
            </div>
            <div class="invalid-feedback">
              {{ errors[0] }}
            </div>
          </validation-provider>
        </div>
        <div
          v-if="template.item && decisionTemplate"
          class="decisions-body-title">
          Orzeczenie: <span>{{template.item ? template.item.name : ''}}</span>
        </div>
        <template v-if="decisionTemplate">
          <div
            v-for="(decisionField, decisionFieldIndex) in decisionTemplate"
            :key="'decision-field-' + decisionFieldIndex">
            <div
              v-if="decisionField.type === 'input'"
              class="form-group decision-box">
              <label
                :for="decisionField.name"
                class="title-box">
                {{ decisionField.label }}
              </label>
              <validation-provider
                :name="decisionField.name"
                v-slot="{ errors }">
                <d-input
                  :type="'text'"
                  :state="errors.length ? 'invalid' : null"
                  v-model="decisionField.value" />
                <div class="invalid-feedback">
                  {{ errors[0] }}
                </div>
              </validation-provider>
              <p
                v-if="decisionField.text"
                class="decision-note">
                {{ decisionField.text }}
              </p>
            </div>
            <div
              v-if="decisionField.type === 'date'"
              class="form-group decision-box">
              <label
                :for="decisionField.name"
                class="title-box">
                {{ decisionField.label }}
              </label>
              <validation-provider
                :name="decisionField.name"
                v-slot="{ errors }">
                <date-picker
                  v-model="decisionField.value"
                  valueType="format"
                  class="mr-2"
                  style="width: 100%" />
                <div class="invalid-feedback">
                  {{ errors[0] }}
                </div>
              </validation-provider>
              <p
                v-if="decisionField.text"
                class="decision-note">
                {{ decisionField.text }}
              </p>
            </div>
            <div
              v-if="decisionField.type === 'textarea'"
              class="form-group decision-box">
              <label
                :for="decisionField.name"
                class="title-box">
                {{ decisionField.label }}
              </label>
              <validation-provider
                :name="decisionField.name"
                v-slot="{ errors }">
                <div :class="{ 'form-control': true, 'is-select': true }">
                  <textarea
                    :type="'text'"
                    :state="errors.length ? 'invalid' : null"
                    v-model="decisionField.value"
                  ></textarea>
                </div>
                <div class="invalid-feedback">
                  {{ errors[0] }}
                </div>
              </validation-provider>
              <p
                v-if="decisionField.text"
                class="decision-note">
                {{ decisionField.text }}
              </p>
            </div>
            <div
              v-if="(decisionField.type === 'select') && (decisionField.multiselect === 0)"
              class="form-group decision-box">
              <validation-provider
                :name="decisionField.name"
                v-slot="{ errors }">
                <label
                  :for="decisionField.name"
                  class="title-box">
                  {{ decisionField.label }}
                </label>
                <div :class="{ 'form-control': true, 'is-select': true }">
                  <v-select
                    :options="decisionField.possibleValues"
                    v-model="decisionField.value"
                    :reduce="boss => boss.id"
                    label="id">
                    <template slot="option" slot-scope="option">
                      <div class="d-center">
                        {{ option.name }}
                      </div>
                    </template>
                    <template slot="selected-option" slot-scope="option">
                      <div class="selected d-center">
                        {{ option.name }}
                      </div>
                    </template>
                  </v-select>
                </div>
                <p
                  v-if="decisionField.text"
                  class="decision-note">
                  {{ decisionField.text }}
                </p>
                <div class="invalid-feedback">
                  {{ errors[0] }}
                </div>
              </validation-provider>
            </div>
            <div
              v-if="(decisionField.type === 'select') && (decisionField.multiselect === 1) && (decisionField.specializations === true)"
              class="form-group decision-box">
              <validation-provider
                :name="decisionField.name"
                v-slot="{ errors }">
                <label
                  :for="decisionField.name"
                  class="title-box">
                  {{ decisionField.label }}
                </label>
                <multi-select
                  @input="getValueFromMultiSelect(decisionField.value)"
                  :multiple="true"
                  :ref="'multi-user-list'"
                  placeholder="Wybierz..."
                  :options="decisionField.possibleValues"
                  v-model="decisionField.value"
                  :track-by="'id'"
                  label="name"
                  select-label="Wybierz"
                  deselectLabel="Usuń wybór"
                  selectedLabel="Wybrane"
                  :taggable="true" />
                <p
                  v-if="decisionField.text"
                  class="decision-note">
                  {{ decisionField.text }}
                </p>
                <div class="invalid-feedback">
                  {{ errors[0] }}
                </div>
              </validation-provider>
              <div
                class="form-group"
                style="display: none">
                <pre>{{usersList}}</pre>
                <pre>{{data.specialization}}</pre>
                <pre>{{specialization}}</pre>
              </div>
              <div
                v-if="(decisionField.type === 'select') && (decisionField.multiselect === 1) && usersList.length && decisionField.specializations === true"
                class="form-group under-box">
                <label
                  :for="decisionField.name"
                  class="title-box">
                  Specjalizacje zespołu orzekającego
                </label>
                <div
                  v-for="(user, index) in usersList"
                  :key="index"
                  class="form-group">
                  <span>
                    <i class="material-icons text-success mr-2">chevron_right</i>
                    <label
                      for="name"
                      class="mr-4 mt-1">
                      {{ user.name }}
                    </label>
                    <validation-provider
                      rules="required"
                      name="specialization-id"
                      v-slot="{ errors }">
                      <div
                        :class="{
                          'form-control is-select': true,
                          'is-invalid': errors.length
                        }">
                        <v-select
                          :options="availableSpecializationsList"
                          @input="pushIdAndSpecialization(user.id, data.specialization[index], index)"
                          :reduce="boss => boss.id"
                          v-model="data.specialization[index]"
                          label="id">
                          <template slot="option" slot-scope="option">
                            <div class="d-center">
                              {{ option.name }}
                            </div>
                          </template>
                          <template slot="selected-option" slot-scope="option">
                            <div class="selected d-center">
                              {{ option.name }}
                            </div>
                          </template>
                        </v-select>
                      </div>
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                    </validation-provider>
                  </span>
                </div>
              </div>
            </div>
            <div
              v-if="(decisionField.type === 'select') && (decisionField.multiselect === 1) && (decisionField.specializations === false)"
              class="form-group decision-box">
              <validation-provider
                :name="decisionField.name"
                v-slot="{ errors }">
                <label
                  :for="decisionField.name"
                  class="title-box">
                  {{ decisionField.label }}
                </label>
                <multi-select
                  :multiple="true"
                  placeholder="Wybierz..."
                  :options="decisionField.possibleValues"
                  v-model="decisionField.value"
                  :track-by="'id'"
                  label="name"
                  select-label="Wybierz"
                  deselectLabel="Usuń wybór"
                  selectedLabel="Wybrane"
                  :taggable="true" />
                <p
                  v-if="decisionField.text"
                  class="decision-note">
                  {{ decisionField.text }}
                </p>
                <div class="invalid-feedback">
                  {{ errors[0] }}
                </div>
              </validation-provider>
            </div>
            <div
              v-if="decisionField.type === 'checkbox'"
              class="form-group decision-box">
              <d-checkbox
                :value="'1'"
                :unchecked-value="'0'"
                v-model="decisionField.value"
                :class="'mb-3'"
                toggle>
                <span class="title-box">{{ decisionField.label }}</span>
              </d-checkbox>
              <p
                v-if="decisionField.text"
                class="decision-note">
                {{ decisionField.text }}
              </p>
            </div>
          </div>
        </template>
        <div class="popup-box-buttons">
          <d-button
            theme="success"
            class="text-nowrap"
            @click.prevent="validateForm">
            Potwierdź
          </d-button>
          <d-button
            theme="secondary"
            class="text-nowrap ml-3"
            @click.prevent="onClosePopup">
            Anuluj
          </d-button>
        </div>
      </validation-observer>
      <div
        v-if="!templatesList"
        class="pb-3 pt-3 text-center">
        Trwa ładowanie danych&hellip;
      </div>
    </d-modal-body>
  </d-modal>
</template>

<script>
import Vue from 'vue';
import FormUtils from '@/utils/FormUtils.js';
import FilterSelect from '@/components/others/FilterSelect';
import DatePicker from 'vue2-datepicker';
import multiSelect from 'vue-multiselect'

export default {
  name: 'patients-form-decisions-popup',
  components: { FilterSelect, DatePicker, multiSelect },
  props: {
    allInstitutions: {
      required: true,
      type: Array
    },
    decision: {
      default: null,
      type: Object
    },
    institutionId: {
      default: 0,
      type: Number
    },
    onClosePopup: {
      default: () => {},
      type: Function
    },
    onSubmitCallback: {
      default: () => {},
      type: Function
    },
    patientId: {
      required: true,
      type: Number
    },
    show: {
      required: true,
      type: Boolean
    },
    visitId: {
      default: 0,
      type: Number
    }
  },
  computed: {
    allDataLoaded () {
      if (!this.data.institution_id) {
        return this.templatesListLoaded;
      }

      return this.dataIsSet && (this.templatesListLoaded || (this.templateForDecision && this.templateForDecision.data_fields));
    },
    isViewLoaded () {
      return this.allDataLoaded && !this.isTemplateLoading;
    },
    patientsDecision () {
      return this.$store.getters.getPatientsDecisionsData
    },
    patientsSpecializations () {
      return this.$store.getters.getPatientsSpecializationDecisionsData
    },
    isEdit () {
      return !!(this.decision && this.decision.id);
    }
  },
  watch: {
    'data.id': function (id) {
      if (!this.dataIsSet) {
        return;
      }

      if (this.isEdit && !this.isDecisionTypeChanged) {
        Vue.set(this, 'isDecisionTypeChanged', true);
      }

      if (!id) {
        this.templateForDecision = {};
        return;
      }

      Vue.set(this, 'isTemplateLoading', true);

      if (id && this.data.institution_id && (!this.isEdit || (this.isEdit && this.isDecisionTypeChanged))) {
        setTimeout(() => {
          this.getDecisionTemplateForPatient(id, this.patientId);
        }, 400)
      }
    },
    patientsDecision (newValue) {
      if (!newValue || !this.dataIsSet) {
        return;
      }

      if (this.isEdit && !this.isDecisionTypeChanged) {
        return;
      }

      let newDecisionTemplate = JSON.parse(JSON.stringify(newValue));
      let newDecisionFields = Object.keys(newDecisionTemplate);

      for (let i = 0; i < newDecisionFields.length; i++) {
        if (!(newDecisionFields[i] in this.decisionTemplate)) {
          // eslint-disable-next-line no-continue
          continue;
        }

        let oldField = this.decisionTemplate[newDecisionFields[i]];
        let newField = newValue[newDecisionFields[i]];
        let oldFieldFields = Object.keys(oldField);
        let newFieldFields = Object.keys(newField);

        if (oldFieldFields.length !== newFieldFields.length || !(oldFieldFields.every((item, index) => item === newFieldFields[index]))) {
          // eslint-disable-next-line no-continue
          continue;
        }

        if (oldField.name !== newField.name || oldField.label !== newField.label || oldField.type !== newField.type || oldField.text !== newField.text) {
          // eslint-disable-next-line no-continue
          continue;
        }

        if (newField.multiselect || newField.possibleValues) {
          // eslint-disable-next-line no-continue
          continue;
        }
        newDecisionTemplate[newDecisionFields[i]].value = oldField.value;
      }

      this.decisionTemplate = newDecisionTemplate;
      Vue.set(this, 'usersList', []);
      Vue.set(this, 'isTemplateLoading', false);
    },
    patientsSpecializations (newValue) {
      Vue.set(this.data, 'specialization', []);
      Vue.set(this, 'availableSpecializationsList', JSON.parse(JSON.stringify(newValue)));
    }
  },
  data () {
    return {
      data: {
        id: '',
        institution_id: '',
        name: '',
        patient_id: '',
        specialization: []
      },
      specialization: [],
      template: [],
      templateForDecision: [],
      templateForDecisionLoaded: false,
      templatesList: [],
      templatesListLoaded: false,
      userKey: 0,
      usersList: [],
      dataIsSet: false,
      isDecisionTypeChanged: false,
      decisionTemplate: {},
      availableSpecializationsList: [],
      isTemplateLoading: true
    };
  },
  mounted () {
    this.getTemplatesList();
    this.preparePopup();

    if (this.isEdit) {
      this.loadItemData();
    } else {
      this.dataIsSet = true;
      Vue.set(this, 'isTemplateLoading', false);
    }
  },
  methods: {
    preparePopup () {
      this.data.patient_id = this.patientId;

      if (this.decision && this.decision.id) {
        Object.assign(this.data, this.guardian);
      }

      Vue.nextTick(() => {
        if (this.$refs['patients-form-decision']) {
          this.$refs['patients-form-decision'].reset();
        }

        this.loaded = true;
      })
    },
    getValueFromMultiSelect(value) {
      this.usersList = value;
    },
    getValueFromMultiSelectEdit () {
      setTimeout(() => {
        for (let i = 0; i < this.specialization.length; i++) {
          if (this.$refs['multi-user-list'] && this.$refs['multi-user-list'][i]) {
            if (this.$refs['multi-user-list'][i].internalValue.length) {
              const refValue = this.$refs['multi-user-list'][i].internalValue;
              let dataRef = [];
              for (let j = 0; j < refValue.length; j++) {
                dataRef[j] = refValue[j].specialization;
                this.usersList[j] = {
                  id: refValue[j].id,
                  name: refValue[j].name
                };
              }
              this.data.specialization = dataRef;
            }
          }
        }
        this.dataIsSet = true;
        this.userKey += 1;
      }, 500);
    },
    pushIdAndSpecialization (value, special, index) {
      this.specialization[index] = {
        id: value,
        specialization: special
      }
    },
    setImage(event) {
      this.data.scan_file = event.target.files[0];
    },
    getTemplatesList () {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/pdf-templates',
        outputKey: 'templatesList',
        loadedKey: 'templatesListLoaded',
        params: {
          pagination: false,
          where: {
            all: true,
          }
        }
      });
    },
    getDecisionTemplateForPatient (id, patient) {
      this.$store.dispatch('patientsDecisionEditGet', { id, patient });
    },
    loadItemData () {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/pdf-documents/item/' + this.decision.id,
        outputKey: 'templateForDecision',
        loadedKey: 'templateForDecisionLoaded',
        successAction: () => {
          this.setUpDecision();
        }
      });
    },
    validateForm () {
      FormUtils.validate(this.$refs['patients-form-decision'], this.submitForm);
    },
    setUpDecision () {
      Vue.set(this.data, 'id', this.templateForDecision.pdf_document_template);
      Vue.set(this.data, 'patient_id', this.templateForDecision.patient_id);
      Vue.set(this.data, 'institution_id', this.templateForDecision.institution_id);
      Vue.set(this, 'specialization', JSON.parse(JSON.stringify(this.templateForDecision.specialization)));

      Vue.set(this, 'decisionTemplate', JSON.parse(JSON.stringify(this.templateForDecision.data_fields)));
      Vue.set(this, 'availableSpecializationsList', JSON.parse(JSON.stringify(this.templateForDecision.specializations)));

      Vue.set(this, 'isTemplateLoading', false);

      Vue.nextTick(() => {
        this.getValueFromMultiSelectEdit();
      })
    },
    submitForm  () {
      let imageFields = false;
      let formDataToSend = {
        pdf_document_template: this.data.id,
        data_fields: this.decisionTemplate,
        patient_id: this.data.patient_id,
        institution_id: this.data.institution_id,
        specialization: this.specialization,
      };
      if (this.visitId) {
        formDataToSend.visit_id = this.visitId;
      }
      let endpointUrl = this.isEdit ? '/pdf-documents/update/' + this.decision.id : '/pdf-documents/store';

      FormUtils.submit(this, {
        endpoint: endpointUrl,
        formData: formDataToSend,
        successTitle: 'Zapisano orzeczenie',
        successText: 'Wybrane orzeczenie zostało zapisane',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Modyfikacje upoważnienia nie powiodły się. Spróbuj ponownie.',
        successAction: () => {
          this.onSubmitCallback();
          this.onClosePopup();
        }
      }, imageFields);
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
  @import '@/assets/scss/patients-form-decisions.scss';
  .patients-form-decisions.is-hidden {
    display: none!important;
    pointer-events: none!important;
  }
</style>
